/**
 * Holds the default configuration.
 *
 * @returns {Object} config.
 * @since 1.0.7
 */
const defaultConfig = {
	string: {
		invoice: "I N V O I C E",
		refNumber: "Ref no",
		date: "Date",
		dueDate: "Due Date",
		status: "Status",
		billTo: "Bill To",
		item: "Item",
		quantity: "Qty",
		price: "Price",
		discount: "Discount",
		tax: "Tax",
		total: "Total",
		subTotal: "Subtotal",
		totalTax: "Total Tax",
		totalDiscount: "Total Discount",
		fee: "Total Fee",
		grandTotal: "Grand Total",
	},
};

module.exports = defaultConfig;
